module.exports = __webpack_public_path__ + "img/13.b3ef863b.jpg";